import axios from 'axios'
import { BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarSeUsuarioVendeEncomendaComCte (codigo) {
  const url = `${URL}/usuarios/empresa/${codigo}/usuario-vende-encomenda-com-cte`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE,
        payload: response

      })
  );
}
